module.exports = __webpack_public_path__ + "img/01-hole.7744b3b2.png";